import React from 'react';
import styled from 'styled-components';

import Container from 'components/Container';
import Stack from 'components/Stack';
import Text from 'components/Text';
import EmbeddedVideo from 'components/EmbeddedVideo';

const Section = styled.section`
  text-align: center;
  padding: 4rem 1.5rem;
`;

const StyledStack = styled(Stack)`
  text-align: center;
  & > * {
    max-width: 56rem;
  }
`;

const Video = styled(EmbeddedVideo)`
  max-width: 47rem;
  z-index: 1;
`;

const VIDEO_URL = 'https://www.youtube.com/embed/wHn3lp700yU';
const VIDEO_TITLE =
  'The Start of Sleuth: Filling a Gap in Software Delivery Performance';

export default function OurMission() {
  return (
    <Section>
      <Container>
        <Stack gap="4.5rem" align="center">
          <StyledStack gap="1.5rem" align="center">
            <Text as="span" color="skyBlue" variant="eyebrow">
              OUR MISSION
            </Text>
            <Text as="h2" variant="heading.section">
              Empower teams to ship faster by making engineering measurable &
              easy to improve.
            </Text>
          </StyledStack>
          <Video src={VIDEO_URL} title={VIDEO_TITLE} />
        </Stack>
      </Container>
    </Section>
  );
}
